import { action as createAction } from "@iva/store-utils";
import { Dispatch } from "redux";
import { GetState, ThunkResult } from "#store/types";
import { DatasourceActionTypes } from "#store/datasources/datasourceTypes";
import { DatasourceDto } from "#services/pilotService/types";
import { datasourceService } from "#services/pilotService";

export const loadDatasources =
    (): ThunkResult<void> => (dispatch: Dispatch, getState: GetState) => {
        // Dispatch action that fetching data has begun
        dispatch(loadDatasourceStarted());

        datasourceService(
            getState().environment.SERVICE_URL,
            getState().uiState.rid
        )
            .list()
            .then(results => {
                dispatch(loadDatasourceSuccess(results));
            })
            .catch(error => {
                dispatch(loadDatasourceFailed(error.message));
            });
    };

function loadDatasourceStarted() {
    return createAction(DatasourceActionTypes.LOAD_START, undefined);
}

function loadDatasourceSuccess(data: DatasourceDto[]) {
    return createAction(DatasourceActionTypes.LOAD_SUCCESS, data);
}

function loadDatasourceFailed(error: unknown | undefined) {
    return createAction(DatasourceActionTypes.LOAD_ERROR, error);
}
